import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { clienteApi, setClienteToken } from "@/lib/api";
import { useClienteAuth } from "@/lib/clienteAuth";
import { toast } from "sonner";
import { Eye, EyeOff, ArrowLeft } from "lucide-react";

export default function PortalLogin() {
  const nav = useNavigate();
  const { refresh } = useClienteAuth();
  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");
  const [mostrar, setMostrar] = useState(false);
  const [enviando, setEnviando] = useState(false);

  const entrar = async (e) => {
    e.preventDefault();
    setEnviando(true);
    try {
      const { data } = await clienteApi.post("/cliente-auth/login", {
        email: email.trim().toLowerCase(),
        senha,
      });
      if (data?.session_token) setClienteToken(data.session_token);
      const info = await refresh();
      const nome = info?.cliente?.nome || "";
      toast.success(nome ? `Bem-vindo(a), ${nome}!` : "Bem-vindo(a)!");
      nav("/portal", { replace: true });
    } catch (e2) {
      const msg = e2?.response?.data?.detail || "E-mail ou senha inválidos.";
      toast.error(typeof msg === "string" ? msg : "Falha no login.");
    } finally {
      setEnviando(false);
    }
  };

  return (
    <div className="min-h-screen bg-zinc-50 flex items-center justify-center p-4">
      <div className="w-full max-w-md bbh-card p-6 sm:p-8">
        <Link to="/" className="inline-flex items-center gap-1 text-xs text-zinc-500 hover:text-zinc-800 mb-4">
          <ArrowLeft className="w-3 h-3" /> Voltar
        </Link>
        <div className="text-[11px] font-semibold uppercase tracking-widest text-zinc-500 mb-1">
          Portal do cliente
        </div>
        <h1 className="font-heading text-2xl sm:text-3xl font-bold tracking-tight mb-1">Entrar</h1>
        <p className="text-sm text-zinc-600 mb-6">
          Acesse seus orçamentos com a BBH.
        </p>
        <form onSubmit={entrar} className="space-y-4" data-testid="login-cliente-form">
          <div>
            <label className="text-[10px] font-semibold uppercase tracking-widest text-zinc-500">E-mail</label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="login-cliente-email"
              autoComplete="email"
              className="mt-1 w-full px-3 py-2.5 rounded-md border border-zinc-200 bbh-input text-sm"
              placeholder="seu@email.com"
            />
          </div>
          <div>
            <label className="text-[10px] font-semibold uppercase tracking-widest text-zinc-500">Senha</label>
            <div className="relative mt-1">
              <input
                type={mostrar ? "text" : "password"}
                required
                value={senha}
                onChange={(e) => setSenha(e.target.value)}
                data-testid="login-cliente-senha"
                autoComplete="current-password"
                className="w-full px-3 py-2.5 pr-10 rounded-md border border-zinc-200 bbh-input text-sm"
              />
              <button
                type="button"
                onClick={() => setMostrar((v) => !v)}
                className="absolute right-2 top-1/2 -translate-y-1/2 p-1.5 text-zinc-400 hover:text-zinc-700"
                aria-label="Mostrar/ocultar senha"
              >
                {mostrar ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
              </button>
            </div>
          </div>
          <button
            type="submit"
            disabled={enviando}
            data-testid="login-cliente-submit"
            className="w-full inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-md bbh-btn-primary text-sm font-semibold disabled:opacity-50"
          >
            {enviando ? "Entrando…" : "Entrar"}
          </button>
          <div className="text-center pt-1">
            <Link to="/portal/esqueci-senha" data-testid="link-esqueci-senha" className="text-xs text-zinc-600 hover:text-zinc-900 underline">
              Esqueci minha senha
            </Link>
          </div>
        </form>
        <div className="text-center text-xs text-zinc-500 mt-4">
          Ainda não tem cadastro? Peça o link de cadastro à BBH.
        </div>
      </div>
    </div>
  );
}
